import {DotFillIcon, MoonIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import type {ReactNode} from 'react'
import styles from './Reviewers.module.css'

function StatusImage({label, className, children}: {label: string; className: string; children: ReactNode}) {
  return (
    <span role="img" aria-label={label} className={className}>
      {/* eslint-disable-next-line github/a11y-no-title-attribute -- pointer label for a noninteractive status image */}
      <span aria-hidden="true" title={label}>
        {children}
      </span>
    </span>
  )
}

export function DeferredStatusIcon({label}: {label: string}) {
  return (
    <StatusImage label={label} className={clsx(styles.statusIcon, 'color-fg-muted')}>
      <MoonIcon size={16} />
    </StatusImage>
  )
}

export function ReviewStatusIndicator({label}: {label: string}) {
  return (
    <StatusImage label={label} className={clsx(styles.statusIcon, 'color-fg-attention')}>
      <DotFillIcon size={16} />
    </StatusImage>
  )
}
